import * as currencyFormatter from 'currency-formatter';

export const currency = (str: string | number) =>
  currencyFormatter.format(str, { code: 'BRL' });

export const parseCurrency = (str: string) => {
  const value = Number(str.replace(/[^0-9]/g, ''));
  return value / 100;
};
